import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children:[
      {
        path: '/',
        name: 'verify',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Home/Verify.vue'),
        props: { default: true },
        meta: {
          // guest: true,
          requiresAuth: true,
      },
    },
    {
      path: '/detail',
      name: 'detail',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Home/Detail.vue'),
      props: { default: true},
      meta: {
        // guest: true,
        requiresAuth: true,
    },
  },
    {
      path: '/billing',
      name: 'bill',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Home/Billing.vue'),
      meta: {
        // guest: true,
        requiresAuth: true,
    }
  },
  {
    path: '/verify',
    name: 'verify',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Home/Verify.vue'),
    meta: {
      // guest: true,
      requiresAuth: true,
    }
 },
  {
  path: '/userman',
  name: 'userman',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import('../views/Home/users.vue'),
  meta: {
    // guest: true,
    requiresAuth: true,
   }
 },{
  path: '/approveschool',
  name: 'approveschool',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import('../views/Home/approveschool.vue'),
  meta: {
    // guest: true,
    requiresAuth: true,
   }
 },
  {
    path: '/info',
    name: 'info',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home/Info.vue'),
    props: true,
    meta: {
      // guest: true,
      requiresAuth: true,
  },
},
  {
    path: '/add',
    name: 'add',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home/Form.vue'),
    meta: {
      // guest: true,
      requiresAuth: true,
  },
}
],
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: {
      guest: true,
      // requiresAuth: true,
  },
  },

  
  
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  const isSignedIn = store.state.provider.loggedIn


  if (to.meta.guest) {
      next()
  } else {
      if (to.meta.requiresAuth) {
          const authorized = (isSignedIn)
          if (authorized) {
              if (to.path === '/' && !store.state.provider.provider_id) {
                  next('/login')
              } else
                  next()
          } else {
              next('/login')
          }
      }
  }
})


export default router
